var wenList = [
    {
        path: '/wenlogin',
        name: 'login6',
        component: () => import('../views/login6.vue')
    },
    {
        path: '/wenScreen',
        name: 'wenScreen',
        meta: {
            activeNav: 'wenScreen',
        },
        component: () => import('../views/wenScreen/index.vue')
    },
    {
        path: '/details3',
        name: 'details3',
        meta: {
            activeNav: 'details3',
        },
        component: () => import('../views/wenScreen/details.vue')
    },
    {
        path: '/archives3',
        name: 'archives3',
        meta: {
            activeNav: 'archives3',
        },
        component: () => import('../views/wenScreen/archives.vue')
    },
]
export default wenList